module.exports = __webpack_public_path__ + "static/media/pisos-flotantes.bd3e8ab0.jpg";